import $ from 'jquery';

// Require plugins
require('slick-carousel');

$(document).ready(() => {
	const $slider = $('.hero__slides');

	const beforeChange = (slick, index) => {
		const $parent = slick.$slider.closest('.hero__slider');
		const $pagerMobile = $parent.find(`.hero__mobile-page--button:eq(${index})`);
		$parent.find('.hero__mobile-page--button.active').removeClass('active');
		$pagerMobile.addClass('active');
	};

	const changeSlide = (slick, index) => {
		const $parent = slick.$slider.closest('.hero__slider');
		const $pager = $parent.find(`.hero__pager--item:eq(${index})`);
		const $slide = slick.$slider.find(`.slick-slide[data-slick-index=${index}]`);
		const speed = $slide.find('[data-speed]').length ? $slide.find('[data-speed]').data('speed') : slick.options.autoplaySpeed;
		$parent.find('.hero__pager--item.active').removeClass('active');
		$parent.find('.hero__pager--progress.active').css({ width: 1 }).removeClass('active');
		$pager.addClass('active');
		$pager.find('.hero__pager--progress').addClass('active').animate({ width: '100%' }, speed);
		if ($slide.find('[data-speed]').length && $slide.find('video').length) {
			$slider.slick('slickPause');
			$slide.find('video')[0].play();
			$slide.find('video').on('ended', () => {
				$slider.slick('slickNext');
			});
		} else {
			$slider.slick('slickPlay');
		}
	};

	$slider.on('init', (event, slick) => {
		setTimeout(() => {
			beforeChange(slick, slick.currentSlide);
			changeSlide(slick, slick.currentSlide);
		}, 100);
	});

	$slider.slick({
		arrows: false,
		autoplay: true,
		autoplaySpeed: 5000,
		pauseOnFocus: false,
		pauseOnHover: false,
	});

	$slider.on('afterChange', (event, slick, currentSlide) => {
		changeSlide(slick, currentSlide);
	});

	$slider.on('beforeChange', (event, slick, currentSlide, nextSlide) => {
		beforeChange(slick, nextSlide);
	});

	$('.hero__pager--item').bind('click', function () {
		$slider.slick('slickGoTo', $(this).data('slide'));
	});

	$('.hero__mobile-page--button').bind('click', function () {
		$slider.slick('slickGoTo', $(this).data('slide'));
	});
});
